<div class="modal-header">
  <h4 id="most-often-used-with-modal" class="modal-title">{{ "Most often used with" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container *ngIf="mostOftenUsedWith !== undefined; else loading">
    <table *ngIf="mostOftenUsedWith.length > 0; else noItems" class="table table-sm table-striped">
      <thead>
        <tr>
          <th>{{ "Equipment item" | translate }}</th>
          <th>{{ "Images in common" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of sortedItems(mostOftenUsedWith)">
          <th>
            <a
              [routerLink]="['/equipment/explorer', entry.item.klass.toLowerCase(), entry.item.id]"
              (click)="modal.dismiss()"
            >
              <astrobin-equipment-item-display-name [item]="entry.item"></astrobin-equipment-item-display-name>
            </a>
          </th>
          <td>
            {{ entry.matches }}
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-secondary" type="button">
    {{ "Close" | translate }}
  </button>
</div>

<ng-template #noItems>
  <astrobin-nothing-here [withAlert]="false" [withInfoSign]="false"></astrobin-nothing-here>
</ng-template>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
